export function loadJSON(manifestUrl, callback) {
  const xObj = new XMLHttpRequest()
  xObj.overrideMimeType("application/json")
  xObj.open("GET", manifestUrl, true)
  xObj.onreadystatechange = function () {
    if (xObj.readyState === 4 && xObj.status === 200) {
      callback(JSON.parse(xObj.responseText))
    }
  }
  xObj.send(null)
}
